import { render, staticRenderFns } from "./MainWindow.vue?vue&type=template&id=f061e9e8&"
import script from "./MainWindow.vue?vue&type=script&lang=js&"
export * from "./MainWindow.vue?vue&type=script&lang=js&"
import style0 from "./MainWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports